// init.ts used to initialize Communication domain components on startup.

import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { sharedItemProviderFactory } from "@/Portal/Services/SharedItemProviderFactory";
import { CommunicationHistorySharedItemProvider } from "./Services/Portal/CommunicationHistorySharedItemProvider";

sharedItemProviderFactory.registerProvider(PortalLinkedItemType.CommunicationHistory, new CommunicationHistorySharedItemProvider());
